import { DatePipe } from "@angular/common";
import { Component, ElementRef, Input, Output, ViewChild, EventEmitter } from "@angular/core";
import { FormBuilder, FormControl, Validators, AbstractControl, FormGroup } from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";

import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged, map, startWith } from "rxjs/operators";
import { ApiService } from "src/app/Services/api.service";
import { CommonServices } from "src/app/Services/common.service";
import { StorageService } from "src/app/Services/storage.service";

// export const DATE_FORMAT = {
//   parse: {
//     dateInput: "DD-MM-YYYY"
//   },
//   display: {
//     dateInput: "DD/MM/YYYY",
//     monthYearLabel: "MMM YYYY",
//     dateA11yLabel: "DD/MM/YYYY",
//     monthYearA11yLabel: "MMMM YYYY"
//   }
// };

@Component({
  selector: 'g10-report-filters',
  templateUrl: './filter.component.html',
  styleUrls: [`./filter.component.css`],
  // providers: [
  //   {
  //     provide: DateAdapter,
  //     useClass: MomentDateAdapter,
  //     deps: [MAT_DATE_LOCALE]
  //   },
  //   { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
  //   DatePipe
  // ]
})


export class ReportsFilterComponent {
  @Input() _type: string;
  @Input() showDownloadBtn: boolean = false;
  @Output() values = new EventEmitter();
  @Output() downloadXL = new EventEmitter();
  @Input() enableAllOption: boolean = false;
  @Input() multiSelectVehicle: boolean = false;
  @Output() allOption = new EventEmitter<void>();

  @ViewChild('search') searchTextBox: ElementRef;
  formFilters: any;
  public formSubmitted: boolean = false;
  localStorage: any;
  myDate;
  maxDate = new Date();
  maxEndDate = new Date();
  timeOptions: string[] = [];
  selectedTime: string;
  // speedLimit = 35;
  public matFormSize = '12px';
  minDate: Date;
  // public startTime = { hour: 10, minute: 0, meriden: 'PM', format: 24, val: 'startTime' };
  // public endTime = { hour: 6, minute: 0, meriden: 'AM', format: 12, val: 'endTime' };

  /* vehicle dropdown variables */
  @ViewChild('vehicleSearch') vehSearchTextBox: ElementRef;
  vehSearchChangeObserver: any;
  public enableVehicleField: boolean = false;
  public showSltdVeh: boolean = false;
  public vehiclelists: any = [];
  public vehiclelistsBackup: any = [];
  public sltdVehicle = [];    // selected vehicle

  public errorObject: any = {};
  selectOption: any;



  constructor(
    private api: ApiService,
    private storage: StorageService,
    private comService: CommonServices,
    private fb: FormBuilder,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.localStorage = this.storage.get('userInfo');
    this.getVehicleList();
    let date = new Date();
    this.maxDate = new Date(date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + (date.getDate()));
    this.maxEndDate = new Date(date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + (date.getDate() - 1));
    this.generateTimeOptions();
  }

  ngOnInit() {
    if (this._type == 'harsh-accelaration' || this._type == "overspeed_alerts") {
      this.selectOption = 'ALL';
    }
    this.reactiveForm();
    this.minDate = new Date(2020, 0, 1);

  }


  //   console.log("this.formFilters.value ",this.formFilters.value)
  //   //  if(type=='dateAllVehicle'){
  //   //   console.log('formData ', formData && formData['value'] && formData.value) 
  //   //     if(formData && formData['value'] && formData['value']['selectedVehicle']=='ALL'){

  //   //     }

  //   //  }
  //    return null;
  // }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  reactiveForm() {
    if (this._type == 'movement') {
      this.formFilters = new FormGroup({
        selectedVehicle: new FormControl('', [Validators.required]),
        sDate: new FormControl('', [Validators.required]),
        eDate: new FormControl('', [Validators.required]),
        timeInteravel: new FormControl('', [])
      });
    } else if (this._type == 'overspeed') {
      this.formFilters = new FormGroup({
        selectedVehicle: new FormControl('', [Validators.required]),
        sDate: new FormControl('', [Validators.required]),
        eDate: new FormControl('', [Validators.required]),
        speedLimit: new FormControl(35, [Validators.required, Validators.pattern('[0-9]{2,3}'), Validators.min(35)]),
      });
    }
    else if (this._type == 'trip_new') {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      // yesterday.toISOString().substring(0, 10)
      this.formFilters = new FormGroup({
        selectedVehicle: new FormControl('', [Validators.required]),
        sDate: new FormControl(yesterday.toISOString().substring(0, 10)),
        eDate: new FormControl(yesterday.toISOString().substring(0, 10)),
      });
    }
    else if (this._type == 'halt') {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      this.formFilters = this.fb.group({
        selectedVehicle: ['', Validators.required],
        sDate: [yesterday.toISOString().substring(0, 10), Validators.required],
        eDate: [yesterday.toISOString().substring(0, 10), Validators.required],
        minutes: [5, Validators.required],
        hours: [0, Validators.required]
      });

    } else if (this._type == 'overspeed_alerts') {
      this.formFilters = new FormGroup({
        selectedVehicle: new FormControl(''),
        sDate: new FormControl('', [Validators.required]),
        eDate: new FormControl('', [Validators.required]),
      });
    }
    else if (this._type == 'towlalert') {
      this.formFilters = this.fb.group({
        selectedVehicle: [''],
        sDate: ['', Validators.required],
        eDate: ['', Validators.required]
      });
    }
    else if (this._type == 'multitrip') {
      this.formFilters = this.fb.group({
        selectedVehicle: [''],
        sDate: ['', Validators.required],
        eDate: ['', Validators.required]
      });
    }
    else if (this._type == 'night-ride-report') { //added  night ride report
      this.formFilters = this.fb.group({
        selectedVehicle: [''],
        sDate: ['', Validators.required],
        eDate: ['', Validators.required]
      });
    }
    else if (['continuous-driving-report'].includes(this._type)) { //added end date
      this.formFilters = this.fb.group({
        selectedVehicle: ['', Validators.required],
        sDate: ['', Validators.required],
        eDate: ['', Validators.required]
      });
    }else if (this._type == 'app_usage_report') {
      const currentday = new Date();
      currentday.setDate(currentday.getDate());
      this.formFilters = this.fb.group({
        selectedVehicle: ['', Validators.required],
        sDate: [currentday.toISOString().substring(0, 10), Validators.required],
        minutes: [1, [Validators.required, Validators.min(1)]],
      });
    } else if (this._type == 'harsh-accelaration') {
      this.formFilters = this.fb.group({
        selectedVehicle: [''],
        sDate: ['', Validators.required],
        eDate: ['', Validators.required]
      });
    }
    else {
      this.formFilters = this.fb.group({
        selectedVehicle: ['', Validators.required],
        sDate: ['', Validators.required],
        eDate: ['', Validators.required]
      });
    }
  }

  getVehicleList(vehRegNo?) {
    this.enableVehicleField = false;
    this.vehiclelists = [];
    const obj = {};
    if (vehRegNo) obj['vehRegNo'] = vehRegNo;

    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          res.data.filter(item => {
            try {
              if (item.model && item.vehRegNo) {
                let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '';
                let vehicleObj = {
                  name: item.vehRegNo.toUpperCase() + ' ' + model,
                  value: item.vehRegNo,
                };
                this.vehiclelists.push(vehicleObj);
              }
            } catch (err) {
              // console.log('vehicle', err);
            }
          });
          if (this.vehiclelists.length > 0 && !this.vehSearchTextBox?.nativeElement?.value) {
            this.vehiclelistsBackup = [...this.vehiclelists];
          }
        }
      }
      setTimeout(() => { this.clearDuplicates(); this.enableVehicleField = true }, 200);
    }).catch((err) => {
      console.log(err);
    });
  }

  // search
  vehSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.vehSearchChangeObserver) {
      new Observable(observer => {
        this.vehSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.getVehicleList(term);
        });
    }
    this.vehSearchChangeObserver.next(searchValue);
  }

  vehSelectionResult(data) {
    this.showSltdVeh = false;
    let result = [];
    let removedResult = [];

    let value = data;
    if (!Array.isArray(value)) value = [value];
    else value = [...value];
    try {

      if (value.includes('ALL')) {
        this.selectOption = value;
        this.setMaxDate('ALL');
        if (this.multiSelectVehicle) value = ['ALL'];
        else value = 'ALL';
        let obj = { name: 'ALL', value: 'ALL' };
        result.push(obj);
        this.formFilters.controls.selectedVehicle.patchValue(value);
      }
      else {
        this.selectOption = '';
        this.setMaxDate('');
        value.map((item) => {
          this.sltdVehicle.map((veh) => {
            if (veh.value == item) {
              let valIndex = result.findIndex((e) => e.value == item.value);
              if (valIndex == -1) result.push(item);
            }
          })
          this.vehiclelists.map((veh) => {
            if (veh.value == item) {
              let valIndex = result.findIndex((e) => e.value == veh.value);
              if (valIndex == -1) result.push(veh);
            }
          })
        })
        this.formFilters.controls.selectedVehicle.patchValue(data);
      }

      this.sltdVehicle.map((veh) => {
        if (!value.includes(veh.value)) {
          let pushObj: boolean = true;
          removedResult.map((e) => { if (e.value == veh.value) pushObj = false; });
          if (pushObj && veh.value != 'ALL') removedResult.unshift(veh);
        }
      })
      this.enableVehicleField = false;
      this.vehiclelists = [...removedResult, ...this.vehiclelists]
      this.enableVehicleField = true;
      this.sltdVehicle = [...result];
    } catch (err) {
      console.log(err);
    }
    this.showSltdVeh = true;
    if (this.vehSearchTextBox && this.vehSearchTextBox.nativeElement) {
      if (this.sltdVehicle) {
        let check = this.vehiclelistsBackup.filter(data => this.sltdVehicle.find(veh => veh.value != data.value))
        this.vehiclelists = [...check]
      }
      this.vehSearchTextBox.nativeElement.value = '';

    }

    this.clearDuplicates();
    if (this.formSubmitted) this.validation();
  }

  clearDuplicates() {
    let result = [];
    this.showSltdVeh = false;
    this.enableVehicleField = false;
    this.vehiclelists.map((vehicleObj) => {

      let pushObj: boolean = true;
      this.sltdVehicle.map((item) => { if (item.value == vehicleObj.value) pushObj = false; });
      if (pushObj) result.push(vehicleObj);

    });
    this.vehiclelists = [...result];
    this.showSltdVeh = true;
    this.enableVehicleField = true;
  }

  clearVehSearch(event) {
    this.vehSearchTextBox.nativeElement.value = '';
    this.getVehicleList();
  }


  /* Invidual form field check */
  public checkError = (controlName: string, errorName: string) => {
    return this.formFilters.controls[controlName].hasError(errorName);
  }
  setMaxDate(data: any) {
    let t_maxDate = new Date(this.formFilters.controls.sDate.value);
    if (['trip_new', 'harsh-accelaration','overspeed',].includes(this._type)) {
      // if (this.selectOption == 'ALL') {
      //   this.formFilters.controls.eDate.setValue('')
      //   t_maxDate.setDate(t_maxDate.getDate() + 0);
      //   if (new Date() > t_maxDate) {
      //     this.maxEndDate = t_maxDate;
      //     this.formFilters.controls.eDate.setValue(t_maxDate)
      //   } else {
      //     this.maxEndDate = new Date();
      //   }
      // } else {
      //   this.formFilters.controls.eDate.setValue('')
      //   t_maxDate.setDate(t_maxDate.getDate() + 2);
      //   if (new Date() > t_maxDate) {
      //     this.maxEndDate = t_maxDate;
      //     this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
      //   } else {
      //     this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
      //     this.maxEndDate = new Date();
      //   }
      // }

      if (this.selectOption == 'ALL') {
        this.formFilters.controls.eDate.setValue('')
        t_maxDate.setDate(t_maxDate.getDate() + 14);
        if (new Date() > t_maxDate) {
          this.maxEndDate = t_maxDate;
          this.formFilters.controls.eDate.setValue(t_maxDate)
        } else {
          this.maxEndDate = new Date();
        }
      } else {
        this.formFilters.controls.eDate.setValue('')
        t_maxDate.setDate(t_maxDate.getDate() + 2);
        if (new Date() > t_maxDate) {
          this.maxEndDate = t_maxDate;
          this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
        } else {
          this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
          this.maxEndDate = new Date();
        }
      }
      // t_maxDate.setDate(t_maxDate.getDate() + 2);
      // if (new Date() > t_maxDate) {
      //   this.maxEndDate = t_maxDate;
      // } else {
      //   this.maxEndDate = new Date();
      // }

    }

      // t_maxDate.setDate(t_maxDate.getDate() + 2);
      // if (new Date() > t_maxDate) {
      //   this.maxEndDate = t_maxDate;
      // } else {
      //   this.maxEndDate = new Date();
      // }
    
    else if(this._type==='night-ride-reports'){
      if (this.selectOption == 'ALL') {
        this.formFilters.controls.eDate.setValue('')
        t_maxDate.setDate(t_maxDate.getDate() + 14);
        if (new Date() > t_maxDate) {
          this.maxEndDate = t_maxDate;
          this.formFilters.controls.eDate.setValue('')
        } else {
          this.maxEndDate = new Date();
        }
      } else {
        this.formFilters.controls.eDate.setValue('')
        t_maxDate.setDate(t_maxDate.getDate());
        if (new Date() > t_maxDate) {
          this.maxEndDate = t_maxDate;
          this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
        } else {
          this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
          this.maxEndDate = new Date();
        }
      }
    }
    else if(this._type==='continuous-driving-report'){
      if (this.selectOption == 'ALL') {
        this.formFilters.controls.eDate.setValue('')
        t_maxDate.setDate(t_maxDate.getDate() + 14);
        if (new Date() > t_maxDate) {
          this.maxEndDate = t_maxDate;
          this.formFilters.controls.eDate.setValue('')
        } else {
          this.maxEndDate = new Date();
        }
      } else {
        this.formFilters.controls.eDate.setValue('')
        t_maxDate.setDate(t_maxDate.getDate());
        if (new Date() > t_maxDate) {
          this.maxEndDate = t_maxDate;
          this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
        } else {
          this.formFilters.controls.eDate.setValue(this.formFilters.controls.sDate.value)
          this.maxEndDate = new Date();
        }
      }
    } else {
      //add a day to the date
      t_maxDate.setDate(t_maxDate.getDate() + 30);

      if (new Date() > t_maxDate) {
        this.maxEndDate = t_maxDate;
      } else {
        this.maxEndDate = new Date();
      }
    }

  }

  validation() {
    this.errorObject = {}
    let isValid: boolean = true;
    let fields = Object.keys(this.formFilters.controls);
    fields.map((field) => {
      if (['continuous-driving-report', 'night-ride-reports'].includes(this._type)) {
        if (this.checkError(field, 'required')) {
          this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required.'
          if (field == 'selectedVehicle') this.errorObject[field] = 'Vehicle is required';
          else if (field == 'sDate') this.errorObject[field] = 'Start Date is required';
          isValid = false;
        }
      }
      else if (['app_usage_report'].includes(this._type)) {
        if (this.checkError(field, 'required')) {
          this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required.'
          if (field == 'selectedVehicle') this.errorObject[field] = 'Vehicle is required';
          else if (field == 'sDate') this.errorObject[field] = 'Start Date is required';
          else if (field == 'minutes') this.errorObject[field] = 'Minutes is required';
          isValid = false;
        }
        if (this.checkError('minutes', 'min') && this._type == 'app_usage_report') {
          if (field == 'minutes') this.errorObject[field] = 'Minutes value should be min 1';
          isValid = false;
        }
      } else {
        if (this.checkError(field, 'required')) {
          this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required.'
          if (field == 'selectedVehicle'){
            this.errorObject[field] = 'Vehicle is required';
            isValid = false;
          }
          else if (field == 'sDate') {
            this.errorObject[field] = 'Start Date is required';
            isValid = false;
          }

          else if (field == 'eDate'){
            if (!["productivity","overspeed_alerts"].includes(this._type)) {
              this.errorObject[field] = 'End Date is required';
              isValid = false;
            }
          } 
          
        }
        else if (!this.checkError('sDate', 'required') && !this.checkError('eDate', 'required')) {
          const f = new Date(this.formFilters.controls['sDate'].value).getTime();
          const t = new Date(this.formFilters.controls['eDate'].value).getTime();
          const veh = this.formFilters.controls['selectedVehicle'].value;
          const datesAreOnSameDay = (first, second) =>
            first.getFullYear() === second.getFullYear() &&
            first.getMonth() === second.getMonth() &&
            first.getDate() === second.getDate();
          if (f > t) {
            this.errorObject['eDate'] = 'Invalid End Date';
            isValid = false;
            if(this._type=="halt"){
              isValid = true;
            }
            if(this._type=="trip_new"){
              if (isNaN(new Date(t).getTime())) 
              {
                this.errorObject[field] = 'End Date is required';
                isValid=false;
              }else{
                isValid=true;
              }
            }
          }

          if (this._type == 'trip_new') {

            if ((veh.includes('ALL') || (Array.isArray(veh) && veh.length > 1)) && f && t) {
              let valid = datesAreOnSameDay(new Date(f), new Date(t));
              isValid = true;
              
              // if (!valid) {
              //   this.errorObject['eDate'] = 'Single day only allowed to download';
              //   isValid = false;
              // }else{
              //   isValid=true;
              // } //by rao
            }else if ((veh.includes('ALL') || (Array.isArray(veh) && veh.length > 1)) && f && (isNaN(new Date(t).getTime())==true)){
              isValid =false;
            }
            else if ((veh.includes('ALL')==false) && veh.length > 1 && f && t){
              isValid =true;
            }
            // else{
            //   console.log("pop3");
            //     isValid =true;
            //    }
             
            
          }
          else if ((veh.includes('ALL') || (Array.isArray(veh) && veh.length > 1)) && f && t) {
            let valid = datesAreOnSameDay(new Date(f), new Date(t));
            if (valid){
              this.errorObject['eDate'] = 'Single day only allowed to download';
              isValid = true;
            }else{
              isValid = true;
            }
          }
        }
        if (field == 'speedLimit' && this.checkError('speedLimit', 'min')) {
          isValid = false;
        }
      }
    });
    return isValid;
  }
  async submitForm() {
     this.formSubmitted = true;
    if (this._type == 'trip_new') {
      if ((this.formFilters.value.sDate == '' || this.formFilters.value.sDate.length == 0) && (this.formFilters.value.eDate == '' || this.formFilters.value.eDate.length == 0)) {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.getTime();
        this.formFilters.get('sDate')?.setValue(yesterday);
        this.formFilters.get('eDate')?.setValue(yesterday);
      }else{
         this.errorObject['eDate'] = 'End Date is required';
      }
      // else if ((this.formFilters.value.sDate != '' || this.formFilters.value.sDate.length > 0) && (this.formFilters.value.eDate != '' || this.formFilters.value.eDate.length > 0) && this.formFilters.value.selectedVehicle.length == 0) {
      //   this.selectOption = 'ALL';
      //   this.setMaxDate('ALL');
      //   this.formFilters.controls['selectedVehicle'].setValue(this.selectOption);
      //}
    }
    
    if (this.validation()) {
      let vehicleData: any = [];
      if (this.formFilters.value.selectedVehicle.includes('ALL')) {
        let ping = 1, i = 0;
        while (ping) {
          let obj = {};
          obj['page'] = i + 1;
          i++;
          let res = await this.api.transportManagerVehicleList(obj).catch((e) => { console.log("Vehicle data not found"); });
          if (res && res['status'] == 'success') {
            if (res['data'].length <= 0) ping = 0;
            else vehicleData = [...vehicleData, ...res['data']];
          } else ping = 0;
        }
      }
      else {
        let obj = { vehicles: this.formFilters.value.selectedVehicle };
        let res = await this.api.transportManagerVehicleList(obj).catch((e) => { console.log("Vehicle data not found"); });
        if (res && res['status'] == 'success') {
          vehicleData = [...res['data']];
        }
      }
      if (vehicleData.length > 0) {
        vehicleData = await this.comService.getObjSingleValue(vehicleData, 'vehRegNo');
      }
      this.clearVehSearch('')
      this.values.emit({ formFilds: this.formFilters.value });
    }
  }
  downloadXlFile() {
    this.downloadXL.emit(true);
  }
  generateTimeOptions() {
    const interval = 30; // 30 minutes interval
    for (let i = 0; i < 24 * 60; i += interval) {
      const hours = Math.floor(i / 60);
      const minutes = i % 60;
      const time = `${this.padZero(hours)}:${this.padZero(minutes)}`;
      this.timeOptions.push(time);
    }
  }
  // Function to pad zero for single-digit hours/minutes
  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  // onChangeHour(event, time) {
  //   console.log("event", event, time)
  // }
}